<button class="btn btn-primary mb-1" [disabled]="!isEnabled || isBlocked" (click)="openPausedTicketsModal()" #button>
    <span class="element-text">{{ 'console.paused' | translate }}</span>
</button>